/**
 * permis-am-bsr-interactif.js
 *
 * Couche interactive pour le Permis AM (ex-BSR) — ados 14+ ans.
 * Ton adapté : plus direct, plus jeunes, peurs spécifiques cyclo.
 */

export const PERMIS_AM_INTERACTIF = {
  briseGlaceOuverture: {
    titre: '🔥 Brise-glace — Avant de commencer',
    consigne: 'Lève la main pour répondre',
    question: 'Selon toi, dans ta tranche d’âge (14-17 ans), combien de jeunes meurent en cyclomoteur chaque année en France ?',
    options: [
      { label: 'Environ 5', correct: false },
      { label: 'Environ 15', correct: false },
      { label: 'Environ 40', correct: true },
      { label: 'Environ 100', correct: false },
    ],
    explication:
      '40 jeunes de 14 à 17 ans meurent chaque année en cyclo. 1 cyclo tué sur 3 est dans ta tranche d’âge. Source : ONISR 2024.',
  },

  etapes: [
    {
      etape: 1,
      briseGlace:
        'Dis ton prénom + pourquoi tu veux ton AM aujourd’hui. Et UNE chose qui te fait un peu peur à l’idée de rouler en scooter.',
      statClef: { valeur: '94%', label: 'des morts AM sont des hommes', detail: 'Statistique masculine écrasante. Filles : restez prudentes, garçons : restez humbles.' },
    },
    {
      etape: 2,
      qcm: {
        question: 'Où est le frein AVANT sur un scooter à variateur (sans embrayage) ?',
        options: [
          { label: 'Main droite (comme une moto classique)', correct: true },
          { label: 'Main gauche', correct: false },
          { label: 'Pédale au pied droit', correct: false },
          { label: 'Pédale au pied gauche', correct: false },
        ],
        explication:
          'Main droite = frein avant (comme une moto). Main gauche = frein arrière (qui sur une moto classique est au pied). Ce détail peut sauver ta vie en urgence : ENTRAÎNE-TOI à le faire AUTOMATIQUEMENT.',
      },
      statClef: { valeur: '45 km/h', label: 'Vitesse max d’un cyclo légal', detail: 'Au-delà = débridage. Au-delà = perte d’assurance.' },
    },
    {
      etape: 3,
      qcm: {
        question: 'Au STOP, dans quel ordre tu regardes ?',
        options: [
          { label: 'Droite → Gauche → Droite', correct: false },
          { label: 'Gauche → Droite → Gauche', correct: true },
          { label: 'Devant uniquement', correct: false },
          { label: 'Tu klaxonnes et tu passes', correct: false },
        ],
        explication:
          'Gauche → Droite → Gauche. Le premier danger vient de la gauche (c’est de là que viennent les véhicules prioritaires sur la voie principale).',
      },
      statClef: { valeur: '0 %', label: 'Tolérance alcool jeune permis', detail: 'C’est non-négociable. Pas un verre. Pas une biere. RIEN.' },
    },
    {
      etape: 4,
      briseGlace:
        "Si un copain te propose de tester son scooter débridé, qu'est-ce que tu dis ?",
      qcm: {
        question: 'Combien de fois plus polluant peut être un cyclo 2-temps qu’une voiture Euro 6 ?',
        options: [
          { label: '10 fois', correct: false },
          { label: '100 fois', correct: false },
          { label: '1000 fois', correct: true },
          { label: '10 000 fois', correct: false },
        ],
        explication:
          'Jusqu’à 1000 fois plus polluant en hydrocarbures qu’une voiture moderne. C’est pour ça que les zones à faibles émissions (ZFE) interdisent progressivement les vieux cyclos.',
      },
    },
    {
      etape: 5,
      briseGlace:
        "Tu as un accident. Qui va payer pour les dégâts s'il s'avère que ton scooter était débridé ?",
      statClef: { valeur: '+30 %', label: 'Risque d’accident en cas de débridage', detail: 'Vitesse, freinage inadapté (pneus et freins prévus pour 45 max), poids machine. Mécanique pousse hors zone sûre.' },
    },
    {
      etape: 6,
      briseGlace:
        "Qu'est-ce que tu n'oseras PLUS faire après ces 8 heures de formation ?",
      statClef: { valeur: '14 ans', label: 'Âge minimum pour le permis AM', detail: 'C’est le 1er permis légal de ta vie. Conserve-le précieusement — il sera ta référence pour la conduite accompagnée plus tard.' },
    },
  ],

  citationFinale: {
    texte: 'Le casque sur la tête ne sauve personne s’il n’est pas attaché. Et un casque attaché ne sauve personne sans la tête qui pense d’abord.',
    auteur: 'Adage prévention routière',
  },
};

export default PERMIS_AM_INTERACTIF;
